import { Stack} from "@mui/material";
import {AnimatedLoader} from "./AnimatedLoader.tsx";

interface IProcessingGalleryCardProps {
    onClick?: () => void
}

export const ProcessingGalleryCard = ({onClick}: IProcessingGalleryCardProps) => {
    return (
        <Stack onClick={onClick} width={'100%'} sx={{ aspectRatio: '1/1', backgroundColor: '#000000', borderRadius: '4px', cursor: 'pointer'}} alignItems={'center'} justifyContent={'center'} spacing={1}>
            <AnimatedLoader size={'50px'}/>
        </Stack>
    )
};
